<template>
  <v-flex xs12 sm6 md4 lg2 py-0>
    <span v-show="brands.length > 1">
      <v-select :items="brands"
                  item-text="name"
                  item-value="id"
                  label="ブランドを選択してください。"
                  no-data-text="ブランドがありません。"
                  v-model="brandId"
                  @change="searchBrand">

        </v-select>
    </span>

    <span v-show="brands.length === 1">
      <v-select :items="brands" item-text="name"
                item-value="id"
                no-data-text="ブランドがありません。"
                :readonly="brands.length === 1"
                v-model="brandId">

      </v-select>
    </span>
  </v-flex>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import eventBus from '@/event_bus'
import eventType from '../constants/eventType'

export default {
  data: () => {
    return {
      brands: [],
      brandId: '',
      brandName: '',
      brandInfo: {}
    }
  },
  created () {
    this.initialize()
  },
  computed: {
    ...mapGetters([
      'currentBrandId',
      'currentBrandName'
    ])
  },
  methods: {
    ...mapMutations([
      'changeCurrentBrandId',
      'changeCurrentBrandName'
    ]),
    initialize () {
      this.axios.get('/api/agent/fetchBrands').then(result => {
        if (result.data.code === 0) {
          this.brands = result.data.data
          if (this.currentBrandId) {
            this.brandId = this.currentBrandId
            this.brandName = this.currentBrandName
            // currentBrandId 만 존재하는 문제가 있어, brandName 이 null 일 경우 받아온 데이터 내에서 한번 더 찾기로 한다.
            if (this.brandName === null && this.brands.length > 0) {
              try {
                this.brandName = this.brands.filter(b => b.id === this.brandId)[0].name
              } catch (e) {}
            }
          } else {
            this.brandId = this.brands[0].id
            this.brandName = this.brands[0].name
            this.changeCurrentBrandId(this.brandId)
            this.changeCurrentBrandName(this.brandName)
          }
          this.searchBrand()
        } else {
          this.$alertMsg(result.data.message)
        }
      })
    },
    searchBrand () {
      let brandIndex = this.brands.findIndex((item, i) => item.id === this.brandId)
      let brand = this.brands[brandIndex]
      this.changeCurrentBrandId(brand.id)
      this.changeCurrentBrandName(brand.name)
      eventBus.$emit(eventType.FETCH_BRAND_INFO, this.currentBrandId)
      eventBus.$emit('brand-loading-complete')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/brand_select.vue